import { Component, OnInit } from '@angular/core';
import { WorkflowActionHistoryComponent } from '@dsvs/workflow-generator-ui-lib';

@Component({
  selector: 'fes-fes-workflow-action-groupchange-history',
  templateUrl: './fes-workflow-action-groupchange-history.component.html',
  styleUrls: ['./fes-workflow-action-groupchange-history.component.scss']
})
export class FesWorkflowActionGroupchangeHistoryComponent extends WorkflowActionHistoryComponent implements OnInit {

  constructor() {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
  }
}
